var generateStyle = function generateStyle(componentTheme) {
  return {
    tableWrapper: {
      display: 'flex',
      flexBasis: '100%',
      flexDirection: 'column',
      paddingBottom: componentTheme.tableBottomPadding
    },
    tableContainer: {
      width: 'calc(25% + 350px)',
      maxWidth: '100%',
      'table tbody tr th': {
        fontWeight: '400'
      }
    }
  };
};
export default generateStyle;